import { render, staticRenderFns } from "./SalesforceConnectButton.vue?vue&type=template&id=67a4093a"
import script from "./SalesforceConnectButton.vue?vue&type=script&lang=ts"
export * from "./SalesforceConnectButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports